module.exports = __webpack_public_path__ + "static/media/AO.f65f59d8.png";